import axios from "axios";

const internTestApi = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
});

/* FETCH TEST */
export const fetchTestById = (testId) =>
  internTestApi.get(`api/intern-test/${testId}`);

export default internTestApi;


